import axios from 'axios';
import Common from "../../componets/Common";

const initialData = {
  mensajeError: ""
}

export const obtenerEstadoBotonPowerpay = async () => {
  
  const url = `${Common.urlAPI}/ObtenerEstadoBotonPowerpay`;    

  try {
    const resp = await axios.get( url );

    return {
      ...initialData,
      estadoPowerpay: resp.data.estadoPowerpay,
      montoMinimoPp: resp.data.montoMinimoPp,
      montoMaximoPp: resp.data.montoMaximoPp
    }

  } catch (err) {
    console.log('error', err);
    const mensajeError = err.response && err.response.status === 401 ? err.response.data.message : err.toString();
    return {
      ...initialData,
      mensajeError
    }
  }

}
